import { Outlet } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import '../styles/Circuit.css';

export default function CircuitCanvas() {
  return (
    <div className="circuit-wrapper" style={{ position: "relative", minHeight: "100vh" }}>
      <canvas id="circuit" style={{ display: 'none' }}></canvas>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Outlet />
      </LocalizationProvider>
      <footer
        style={{
          position: 'relative',
          bottom: '0px',
          left: '0px',
          width: '100%',
          textAlign: 'center',
          fontSize: '0.85em',
          padding: '24px 0',
          color: '#64748b',
        }}
      >
        <p style={{ margin: 0, color: '#64748b' }}>
          Background Image Attribution:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://dynamiccircuit.kihtrak.com/"
            style={{ color: '#0284c7', textDecoration: 'none' }}
          >
            Dynamic Circuit by Karthik Sankar
          </a>
        </p>
      </footer>
    </div>
  );
}
